<div class="card">
  <div class="card-header d-flex justify-content-between align-items-start">
    <h4>{{ "EMPLOYEE_STANDBY_COMMISSION" | translate }}</h4>
    <a *ngIf="!!employeeList || employeeList.length > 1" routerLink="/dashboard/costs/structure-cost-list">{{ "VIEW" | translate }}</a>
  </div>
  <div class="card-body">
    <div *ngIf="!employeeList || employeeList.length < 1">{{ "ALERT.NOT_FOUND_USER_STANDBY_COMMISSION" | translate }}</div>
    <div *ngFor="let employee of employeeList" class="row mb-05">
      <div class="col-lg-6">
        <a [routerLink]="employee.user.type_code === 'employee' ? '/dashboard/user/profile/' + employee.user.user_hash : '/dashboard/collaborators/edit/' + employee.user.user_hash"
           class="text-capitalize font-weight-medium text-break-line-1 mb-0">{{ employee.user.complete_name }}</a>
      </div>
      <div class="col-lg-6">
        <span>{{ employee.from | date: "dd/MM/yyyy" }}</span>
        <span *ngIf="employee.to"> - {{ employee.to | date: "dd/MM/yyyy" }}</span>
      </div>
    </div>
  </div>
</div>
